import { CSSProperties } from "react";

export enum DATA_TYPE_NEW_TABLE{
  DEFAULT = "DEFAULT",
  DATE = "DATE",
  CURRENCY = "CURRENCY"
}

export interface IColumnNewTable extends React.HTMLProps<HTMLElement>{
  id?: string;
  isAction?: boolean;
  styleHead?: CSSProperties;
  styleBody?: CSSProperties;
  headerStyle?: object;
  sort?: boolean;
  text?: string;
  dataField: string;
  type?: "DEFAULT"|"DATE"|"CURRENCY";
  mask?: Function;
  headerNowrap?: boolean;
  bodyNowrap?: boolean;
  order?: number;
}